/** Utilitaires de capture NFC - gère la traduction des layouts clavier.
 *
 * Le lecteur ACR1281U-C2 envoie les caractères selon un layout QWERTY US.
 * Sur un système AZERTY français, les chiffres et la lettre A sont mal interprétés.
 * Cette fonction traduit l'entrée brute en UID hexadécimal propre.
 */

// Mapping AZERTY → QWERTY pour les caractères hexadécimaux
const AZERTY_TO_HEX: Record<string, string> = {
  // Chiffres : rangée du haut AZERTY (sans Shift)
  'à': '0',
  '&': '1',
  'é': '2',
  '"': '3',
  "'": '4',
  '(': '5',
  '-': '6',
  '§': '6', // AZERTY belge : la touche 6 produit « § »
  'è': '7',
  '_': '8',
  '!': '8', // AZERTY belge : la touche 8 produit « ! »
  'ç': '9',
  // Lettre A : position Q sur AZERTY
  'q': 'A',
  'Q': 'A',
};

/** Normalise un UID capturé par un lecteur NFC HID.
 *
 * Tolère les layouts AZERTY français en traduisant les caractères mal interprétés.
 * Filtre les caractères non hexadécimaux et met en majuscules.
 */
export function normalizeBadgeUid(raw: string): string {
  const translated = Array.from(raw)
    .map((c) => AZERTY_TO_HEX[c] ?? c)
    .join('');
  // Garde uniquement les caractères hexadécimaux
  return translated.toUpperCase().replace(/[^0-9A-F]/g, '');
}
